import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/filter/car.svg'


const _withScopeId = n => (_pushScopeId("data-v-60f5db87"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  ref: "modalEl",
  class: "modal fade",
  id: "infoVeiculo",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-xl modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header p-5\" data-v-60f5db87><div class=\"d-flex flex-row\" data-v-60f5db87><div id=\"imgBack\" data-v-60f5db87><img src=\"" + _imports_0 + "\" alt=\"\" data-v-60f5db87></div><div class=\"d-flex flex-column justify-content-center align-items-start\" data-v-60f5db87><span class=\"m-0 subtitulo cor_texto_1\" data-v-60f5db87>Informações do veículo</span><p style=\"font-size:11px;\" class=\"m-0 legenda text-muted\" data-v-60f5db87>Veja mais detalhes sobre o veículo</p></div></div><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-60f5db87></button></div>", 1)
const _hoisted_6 = {
  class: "modal-body",
  id: "modalBody"
}
const _hoisted_7 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "row d-flex justify-content-between" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "titulo" }, "Veículo", -1))
const _hoisted_12 = { class: "col-lg-3 d-flex flex-column" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Marca "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " * ")
], -1))
const _hoisted_14 = { class: "col-lg-7" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Modelo "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " * ")
], -1))
const _hoisted_16 = { class: "col-lg-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Código Modelo "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " * ")
], -1))
const _hoisted_18 = { class: "col-lg-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Fipe "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " * ")
], -1))
const _hoisted_20 = { class: "col-lg-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Ano Combustível "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " * ")
], -1))
const _hoisted_22 = { class: "col-lg-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Ano "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " * ")
], -1))
const _hoisted_24 = { class: "col-lg-2 d-flex flex-column" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Combustivel "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " * ")
], -1))
const _hoisted_26 = { class: "col-lg-6" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Array Combustível "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " * ")
], -1))
const _hoisted_28 = { class: "col-lg-6" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Link do manual", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1))
const _hoisted_31 = { class: "row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "titulo" }, "Lubrificação do Motor", -1))
const _hoisted_33 = { class: "col-lg-2" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "SAE", -1))
const _hoisted_35 = { class: "col-lg-2" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Carter com Filtro", -1))
const _hoisted_37 = { class: "col-lg-2 d-flex flex-column" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Base", -1))
const _hoisted_39 = { class: "col-lg-2" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "API", -1))
const _hoisted_41 = { class: "col-lg-2" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ACEA", -1))
const _hoisted_43 = { class: "col-lg-2" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "OEM", -1))
const _hoisted_45 = { class: "col-lg-2" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ILSAC", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1))
const _hoisted_48 = { class: "row" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "titulo" }, "Pneus", -1))
const _hoisted_50 = { class: "col-lg-3" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pneu Dianteiro 1", -1))
const _hoisted_52 = { class: "col-lg-3" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pneu Dianteiro 2", -1))
const _hoisted_54 = { class: "col-lg-3" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pneu Traseiro 1", -1))
const _hoisted_56 = { class: "col-lg-3" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pneu Traseiro 2", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1))
const _hoisted_59 = { class: "row" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "titulo" }, "Palhetas", -1))
const _hoisted_61 = { class: "col-lg-4" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Modelo", -1))
const _hoisted_63 = { class: "col-lg-2" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tam. Motorista", -1))
const _hoisted_65 = { class: "col-lg-2" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tam. Passageiro", -1))
const _hoisted_67 = { class: "col-lg-2" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tam. Traseiro", -1))
const _hoisted_69 = { class: "col-lg-2" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Adaptador", -1))
const _hoisted_71 = { class: "modal-footer d-flex w-100 justify-content-between" }
const _hoisted_72 = { class: "d-flex flex-row gap-3" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  fill: "white",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M448 384H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64H396.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V320c0 35.3-28.7 64-64 64zM64 128h96v48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H256c8.8 0 16-7.2 16-16V416h48v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64z" })
], -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  fill: "white",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M160 0c-23.7 0-44.4 12.9-55.4 32H48C21.5 32 0 53.5 0 80V400c0 26.5 21.5 48 48 48H192V176c0-44.2 35.8-80 80-80h48V80c0-26.5-21.5-48-48-48H215.4C204.4 12.9 183.7 0 160 0zM272 128c-26.5 0-48 21.5-48 48V448v16c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V243.9c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1H320 272zM160 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" })
], -1))
const _hoisted_75 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_77 = [
  _hoisted_76
]
const _hoisted_78 = {
  key: 1,
  width: "20",
  height: "20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 416c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z" }, null, -1))
const _hoisted_80 = [
  _hoisted_79
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("form", {
            onSubmit: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.updateSend && _ctx.updateSend(...args))),
            class: "m-0 p-0"
          }, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.spanWarning)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    (!_ctx.isFipeValid || !_ctx.isAnoCombustivelValid)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, " Existem campos com formatos incorretos. Verifique os ícones em vermelho. "))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, " Preencha todos os campos obrigatórios marcados com *. "))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.CarUpdated.marca,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.CarUpdated.marca) = $event)),
                    filterable: "",
                    placeholder: "Selecione uma marca",
                    clearable: "",
                    "arrow-class": "custom-arrow"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marcasDeVeiculos, (montadora, key) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: key,
                          label: montadora.marca,
                          value: montadora.marca
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.modelo,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.CarUpdated.modelo) = $event)),
                    placeholder: "Modelo",
                    clearable: "",
                    type: "text",
                    class: "mb-2"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.codModelo,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.CarUpdated.codModelo) = $event)),
                    onInput: _cache[3] || (_cache[3] = (val) => _ctx.validateOnlyNumbers(val, 'codModelo')),
                    inputmode: "numeric",
                    placeholder: "Código Modelo",
                    clearable: "",
                    class: "mb-2"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.fipe,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.CarUpdated.fipe) = $event)),
                    onInput: _ctx.handleFipeInput,
                    maxlength: 8,
                    placeholder: "000000-0",
                    class: _normalizeClass(_ctx.CarUpdated.fipe ? (_ctx.isFipeValid ? 'is-valid' : 'is-invalid') : '')
                  }, null, 8, ["modelValue", "onInput", "class"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.ano,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.CarUpdated.ano) = $event)),
                    placeholder: "2026 Gasolina",
                    class: _normalizeClass(_ctx.CarUpdated.ano ? (_ctx.isAnoCombustivelValid ? 'is-valid' : 'is-invalid') : '')
                  }, null, 8, ["modelValue", "class"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.ano2,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.CarUpdated.ano2) = $event)),
                    onInput: _cache[7] || (_cache[7] = (val) => _ctx.validateOnlyNumbers(val, 'ano2')),
                    maxlength: 4,
                    inputmode: "numeric",
                    placeholder: "2026"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.CarUpdated.combustivel,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.CarUpdated.combustivel) = $event)),
                    filterable: "",
                    placeholder: "Combustível",
                    clearable: "",
                    class: "mb-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Alcool",
                        value: "Alcool"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Diesel",
                        value: "Diesel"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Elétrico",
                        value: "Elétrico"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Flex",
                        value: "Flex"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Gasolina",
                        value: "Gasolina"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Híbrido",
                        value: "Híbrido"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.array_combustivel,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.CarUpdated.array_combustivel) = $event)),
                    placeholder: "Gasolina, Alcool, Diesel, Elétrico",
                    clearable: "",
                    type: "text",
                    class: "mb-2"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.manual,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.CarUpdated.manual) = $event)),
                    placeholder: "Link do Manual",
                    clearable: "",
                    type: "text",
                    class: "mb-2"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.lubrificante_sae,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.CarUpdated.lubrificante_sae) = $event)),
                    placeholder: "0W50",
                    clearable: "",
                    type: "text",
                    class: "mb-2"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.carter_com_filtro,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.CarUpdated.carter_com_filtro) = $event)),
                    placeholder: "Carter c/ Filtro",
                    clearable: "",
                    type: "text",
                    class: "mb-2"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.CarUpdated.lubrificante_base,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.CarUpdated.lubrificante_base) = $event)),
                    placeholder: "Tipo do Óleo",
                    clearable: "",
                    class: "mb-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Mineral",
                        value: "Mineral"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Semisintético",
                        value: "semisintetico"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Sintético",
                        value: "sintetico"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.lubrificante_api,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.CarUpdated.lubrificante_api) = $event)),
                    placeholder: "SP",
                    clearable: "",
                    type: "text",
                    class: "mb-2"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.lubrificante_acea,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.CarUpdated.lubrificante_acea) = $event)),
                    placeholder: "ACEA",
                    clearable: "",
                    type: "text",
                    class: "mb-2"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.lubrificante_oem,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.CarUpdated.lubrificante_oem) = $event)),
                    placeholder: "OEM",
                    clearable: "",
                    type: "text",
                    class: "mb-2"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.lubrificante_ilsac,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.CarUpdated.lubrificante_ilsac) = $event)),
                    placeholder: "ILSAC",
                    clearable: "",
                    type: "text",
                    class: "mb-2"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _hoisted_47,
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.pneu_dianteiro_1,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.CarUpdated.pneu_dianteiro_1) = $event)),
                    placeholder: "175/70R14 82T",
                    clearable: "",
                    type: "text",
                    class: "mb-2"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.pneu_dianteiro_2,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.CarUpdated.pneu_dianteiro_2) = $event)),
                    placeholder: "175/70R14 82T",
                    clearable: "",
                    type: "text",
                    class: "mb-2"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _hoisted_55,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.pneu_traseiro_1,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.CarUpdated.pneu_traseiro_1) = $event)),
                    placeholder: "175/70R14 82T",
                    clearable: "",
                    type: "text",
                    class: "mb-2"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _hoisted_57,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.pneu_traseiro_2,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.CarUpdated.pneu_traseiro_2) = $event)),
                    placeholder: "175/70R14 82T",
                    clearable: "",
                    type: "text",
                    class: "mb-2"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _hoisted_58,
              _createElementVNode("div", _hoisted_59, [
                _hoisted_60,
                _createElementVNode("div", _hoisted_61, [
                  _hoisted_62,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.modelo_palheta,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.CarUpdated.modelo_palheta) = $event)),
                    placeholder: "Flat/Convencional",
                    clearable: "",
                    type: "text",
                    class: "mb-2"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _hoisted_64,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.motorista_palheta,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.CarUpdated.motorista_palheta) = $event)),
                    placeholder: "",
                    clearable: "",
                    type: "text",
                    class: "mb-2"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _hoisted_66,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.passageiro_palheta,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.CarUpdated.passageiro_palheta) = $event)),
                    placeholder: "",
                    clearable: "",
                    type: "text",
                    class: "mb-2"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _hoisted_68,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.traseiro_palheta,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.CarUpdated.traseiro_palheta) = $event)),
                    placeholder: "",
                    clearable: "",
                    type: "text",
                    class: "mb-2"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _hoisted_70,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.CarUpdated.adaptador_palheta,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.CarUpdated.adaptador_palheta) = $event)),
                    placeholder: "",
                    clearable: "",
                    type: "text",
                    class: "mb-2"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _createVNode(_component_Button, {
                  type: "button",
                  variant: "secondary",
                  text: "Copiar",
                  onClick: _cache[27] || (_cache[27] = ($event: any) => (!_ctx.loadSalvar && _ctx.copiarDadosTecnicosDoVeiculo()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_73
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  type: "button",
                  variant: "secondary",
                  text: "Colar",
                  onClick: _cache[28] || (_cache[28] = ($event: any) => (!_ctx.loadSalvar && _ctx.colarDadosTecnicosNoVeiculo())),
                  style: _normalizeStyle(`opacity: ${ Object.keys(_ctx.infoTecnicasCopiado).length > 0 ? 1 : 0.3}`)
                }, {
                  default: _withCtx(() => [
                    _hoisted_74
                  ]),
                  _: 1
                }, 8, ["style"])
              ]),
              _createVNode(_component_Button, {
                type: "submit",
                variant: "primary",
                text: "Salvar"
              }, {
                default: _withCtx(() => [
                  (_ctx.loadSalvar)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_75, _hoisted_77))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_78, _hoisted_80))
                ]),
                _: 1
              })
            ])
          ], 32)
        ])
      ])
    ], 512)
  ]))
}